module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HPHQ49.ad2dcf76.jpg";